// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-menu-item[data-v-2118953d]{display:flex;flex-direction:column;align-items:center;gap:4px;justify-content:center;width:60px;height:44px}.mobile-menu-item span[data-v-2118953d]{white-space:nowrap;font-family:Montserrat;font-weight:500;font-size:12px;line-height:16px;letter-spacing:-.4px;color:hsla(0,0%,100%,.6)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
